/*
 * File: main.js
 * Created Date: 2023.2.14
 * Author : TaekHwan.Park (taekhwan.park@gmail.com)
 *
 * Copyright (c) 2023 Fyltech PTE., LTD., Inc
 */

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './styles/tailwind_3.1.8.css'        // download from https://live.arkscan.io/

import VueAxios from 'vue-axios'
import vClickOutside from 'click-outside-vue3'

import ApiService from './services/api.service'
import FdsApiService from './services/fds-api.service'

const app = createApp(App)

// Composition API: Dependency Injection
const globalMonthShowingData = [
    { ctx_datetime: '2022-06', cnt: '126730' },
    { ctx_datetime: '2022-07', cnt: '188254' },
    { ctx_datetime: '2022-08', cnt: '246974' },
    { ctx_datetime: '2022-09', cnt: '227660' },
    { ctx_datetime: '2022-10', cnt: '278626' },
    { ctx_datetime: '2022-11', cnt: '304058' },
    { ctx_datetime: '2022-12', cnt: '279571' },
]
app.provide('globalMonthShowingData', globalMonthShowingData)

app.use(VueAxios, ApiService, FdsApiService)
app.use(router);
app.use(store)
app.use(vClickOutside)
app.mount('#app')